// extracted by mini-css-extract-plugin
module.exports = {"commonContent":"style_commonContent__Aq_YG","smallContent":"style_smallContent__1I0SW","darkContent":"style_darkContent__s9WAF"};